export const SCAN_SEPARATOR_REGEX = /[-/'\\]/

export function normalizeScanCode (code) {
  if (!code) return ''
  return String(code).trim().toLowerCase().replace(/[-/'\\]/g, '-')
}

export function stripScanPrefix (code) {
  let normalized = normalizeScanCode(code)

  while (normalized.startsWith('-')) {
    normalized = normalized.slice(1).trim()
  }

  return normalized
}



// WEBPACK FOOTER //
// ./src/helpers/scanCode.js